import React from 'react';
import {
  NotificationContainer,
  NotificationManager
} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import '../css/NotificationStyle.css';


export default class Error extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      types: this.props.type,
      message: this.props.message
    };
    this.createNotification = this.createNotification.bind(this);
  }
  //Bug Fix #143 -> Checking to see if the Message is the same before rendering
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.message === nextProps.message) return false;
    return true;
  }

  createNotification(type) {
    console.debug('createNotification', type);
    var message = this.props.message;

    switch (type) {
      case 'info':
        NotificationManager.info(message);
        break;
      case 'success':
        NotificationManager.success(message, 'Success');
        break;
      case 'warning':
        NotificationManager.warning(message, 'Close after 3000ms', 3000);
        break;
      case 'error':
        NotificationManager.error(message, 'Error Message', 5000, () => {
          //alert('callback');
        });

        break;
      default:
        console.debug('default');
        break;
    }
  }

  render() {
    //console.debug("this.props.type = ",this.state.types);

    return (
      <div>
        {this.props.type !== null && this.props.type !== ''
          ? this.createNotification(this.props.type)
          : ''}
        {/*             
        <button className='btn btn-info'
          onClick={this.createNotification('info')}>Info
        </button>
        <hr/>
        <button className='btn btn-success'
          onClick={this.createNotification('success')}>Success
        </button>
        <hr/>
        <button className='btn btn-warning'
          onClick={this.createNotification('warning')}>Warning
        </button>
        <hr/>
        <button className='btn btn-danger'
          onClick={this.createNotification('error')}>Error
        </button> */}

        <NotificationContainer />
      </div>
    );
  }
}
